const styles = {
  root: { mt: 1 },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 1,

  },
  button: {
    backgroundColor: 'background.default',
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: 1,
    borderColor: 'background.grey400',
    boxShadow: '0px 66px 18px 0px rgba(120, 120, 120, 0)',
    '& svg > * ': {
      fill: '#000',
    },
    '&.selected': {
      borderColor: (theme) => `${theme.palette.background.black}!important`,
    },
  },
  itemName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'break-spaces',
    mt: 1,
    minHeight: 30,
    textAlign: 'center',
    '&.MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },
}

export default styles
